"use strict";

exports.__esModule = true;
exports.UiPreferencesContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiPreferences = require("./uiPreferences");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * The signed-in user's interface preferences and the feature flags that
 * result from applying them to the environment's. `enabled` says whether the
 * environment lets users choose at all (ENABLE_UI_PREFERENCES): the navbar
 * switch and the Interface dialog exist only where it does. Without a
 * provider `effectiveFlags` is undefined and consumers fall back to the
 * environment.
 */
var UiPreferencesContext = exports.UiPreferencesContext = /*#__PURE__*/_react["default"].createContext({
  preferences: _uiPreferences.EMPTY_UI_PREFERENCES,
  environment: undefined,
  effectiveFlags: undefined,
  enabled: false,
  loading: false,
  syncEnabled: false,
  update: function update() {
    return Promise.resolve();
  },
  reset: function reset() {
    return Promise.resolve();
  },
  save: function save() {
    return Promise.resolve();
  }
});